import React, { memo, useMemo } from 'react';
import { Button, SageTokens, Tooltip } from '@kajabi/sage-react';

import CopyMagic from 'common/components/CopyMagic';

import {
  appendContentToEditor,
  appendContentToNewEditor,
} from 'common/components/CopyMagic/shared/dataHelpers';
import { ProductEvents } from 'common/components/CopyMagic/CopyMagic.types';
import { ContentAssistantResultType } from 'common/components/CopyMagic/generators/ContentAssistant/ContentAssistant.types';

type Props = {
  editorRef: any;
  productArea: string;
  suffix?: string;
  prefix?: string;
  scopedClassName?: string;
  editorType?: string;
};

const copyMagicButton = (
  <Tooltip content="✨ Content assistant">
    <Button iconOnly subtle icon={SageTokens.ICONS.AI_WRITER_FILLED}>
      Content Assistant
    </Button>
  </Tooltip>
);

const ContentAssistantButton = ({
  editorRef,
  productArea,
  prefix = 'Copy Assistant',
  suffix = 'Builder',
  scopedClassName = '',
  editorType = 'TinyMce',
}: Props) => {
  const productEvents: ProductEvents = useMemo(
    () => ({
      prefix,
      suffix,
      payload: {
        'Product Area': productArea,
      },
    }),
    [productArea, prefix, suffix],
  );

  const onApply = (result: ContentAssistantResultType) => {
    if (editorType === 'TinyMce' && editorRef?.current?.editor) {
      appendContentToEditor(editorRef.current.editor, result?.content);
    } else if (editorType === 'Tiptap') {
      appendContentToNewEditor(editorRef, result?.content);
    }
  };

  return (
    <div className={`copy-magic-tinymce ${scopedClassName}`}>
      <CopyMagic
        trigger={copyMagicButton}
        generatorName={CopyMagic.GENERATORS.CONTENT_ASSISTANT}
        productEvents={productEvents}
        onApply={onApply}
        scopedClassName={scopedClassName}
      />
    </div>
  );
};

export default memo(ContentAssistantButton);
